import CSS from './CloseButton.module.css';
import CloseIcon from '@CS/assets/close.svg?react';

type CloseButtonProps = { onClick?: () => void };

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button
    className={CSS.closeButton}
    data-cuelume-press
    onClick={onClick}
    role="button"
  >
    <CloseIcon />
  </button>
);
